import { gql } from '@apollo/client';

export const EXPORT_SCHOOL_ENROLMENT = gql`
  query ExportSchoolEnrolment($input: ExportArgs!) {
    exportSchoolEnrolment(input: $input) {
      id
      name
      focusSubjects {
        id
        name
      }
      grades {
        id
        name
        value
      }
      programme {
        id
        name
      }
      serviceProviders {
        id
        name
      }
      subjects {
        id
        name
        subjectGradeReference
      }
      schoolEnrolmentData {
        id
        circuit {
          id
          name
        }
        district {
          id
          name
        }
        emisNumber
        grade {
          id
          value
        }
        institution {
          id
          emisNumber
          name
        }
        numberEnrolled
        numberWithoutID
        promotionStatus {
          id
          name
        }
        term
        year
      }
    }
  }
`;
